import React, { useState, useEffect } from 'react'
import { Button, Flex, Text, SVG, Grid } from 'system'

import {
  usePrismicPreviewStoreState,
  usePrismicPreviewStoreActions,
} from '../hooks/usePrismicPreviewStore'
import { useClipboard } from '../hooks/useClipboard'
import { ReactComponent as AssetIconLayoutSVG } from '../assets/layout.svg'
import { ReactComponent as AssetIconEyeSVG } from '../assets/eye.svg'
import { ReactComponent as AssetIconChevronRightSVG } from '../assets/chevron-right.svg'
import { ReactComponent as AssetIconLinkSVG } from '../assets/link.svg'

import { ToggleButton } from './ToggleButton'

const Label = ({ children, ...props }) => (
  <Text as="p" color="#C3DAFE" mr=".75rem" fontWeight="bold" {...props}>
    {children}
  </Text>
)

const SVGIcon = ({ svg, ...props }) => (
  <SVG x={1} y={1} color="#C3DAFE" width="1rem" svg={svg} {...props} />
)

const extractFirstTitle = (pages = {}) => {
  const page = Object.values(pages)[0]
  const firstPageDataKey = Object.keys(page)[0]
  if (!firstPageDataKey) return

  return page[firstPageDataKey]?.data?.title?.text
}

export const PreviewIndicator = () => {
  const {
    previewsEnabled,
    hasPreviews,
    numPreviewedPages,
    pages,
    shareLink,
  } = usePrismicPreviewStoreState()
  const { togglePreviews } = usePrismicPreviewStoreActions()
  const { write } = useClipboard()
  const [isShowingPopover, setIsShowingPopover] = useState(false)

  const isPreviewingOnePage = numPreviewedPages === 1
  const singularPreviewPageTitle =
    isPreviewingOnePage && extractFirstTitle(pages)

  const handleShareClick = async () => {
    await write(shareLink)
    setIsShowingPopover(true)
  }

  useEffect(() => {
    let timeoutId
    if (isShowingPopover)
      timeoutId = setTimeout(() => setIsShowingPopover(false), [2000])

    return () => clearTimeout(timeoutId)
  }, [isShowingPopover])

  return hasPreviews ? (
    <Text
      position="fixed"
      width={[null, '450px']}
      bg="#667EEA"
      bottom={['10px', '30px']}
      left={['10px', '30px']}
      right={['10px', 'initial']}
      zIndex={1000}
      py="1.25rem"
      px="2rem"
      color="white"
      fontSize={['.875rem', '1rem']}
      fontFamily="system-ui"
      borderRadius="8px"
      boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.3)"
    >
      <Flex
        mb="1rem"
        pb="1rem"
        justifyContent="space-between"
        alignItems="center"
        borderBottom="1px solid"
        borderColor="#7F9CF5"
      >
        <Text
          as="h4"
          color="white"
          fontWeight="heavy"
          fontSize={['1rem', '1.25rem']}
        >
          Website Preview
        </Text>

        {/*
        <Flex
          as={Button}
          alignItems="center"
          fontSize={['.875rem', '1rem']}
          fontWeight="semibold"
          fontFamily="system-ui"
          color="#C3DAFE"
          transitionProperty="color"
          onClick={handleShareClick}
          position="relative"
          cursor="pointer"
          outline="none"
          css={{
            '&:hover': {
              color: 'white',

              '.linkIconBG': {
                backgroundColor: 'white',
              },
            },
          }}
        >
          <Flex
            width={['1.25rem', '1.5rem']}
            height={['1.25rem', '1.5rem']}
            bg="#A3BFFA"
            borderRadius="50%"
            mr=".35rem"
            justifyContent="center"
            className="linkIconBG"
            transitionProperty="background"
          >
            <SVGIcon
              svg={AssetIconLinkSVG}
              mr={0}
              color="#5A67D8"
              width=".75rem"
            />
          </Flex>

          <Text
            opacity={isShowingPopover ? 0 : 1}
            transitionProperty="opacity"
            visibility={isShowingPopover ? 'hidden' : 'visible'}
          >
            Copy share link
          </Text>
          <Text
            opacity={isShowingPopover ? 1 : 0}
            visibility={isShowingPopover ? 'visible' : 'hidden'}
            transitionProperty="opacity, visibility"
            position="absolute"
            left="1.85rem"
          >
            Copied!
          </Text>
        </Flex>
        */}
      </Flex>

      <Grid alignItems="center" gridTemplateColumns="1fr auto">
        <Grid
          gridTemplateColumns="1rem auto auto"
          gridColumnGap=".35rem"
          gridRowGap=".35rem"
          alignItems="end"
          justifyContent="start"
        >
          <SVGIcon svg={AssetIconLayoutSVG} />
          <Label>Previewing:</Label>
          <Flex
            as={Text}
            alignItems="flex-end"
            fontWeight="semibold"
            mr=".25rem"
          >
            {isPreviewingOnePage
              ? singularPreviewPageTitle
              : `${numPreviewedPages} Pages`}
            {!isPreviewingOnePage && (
              <Button
                as={SVGIcon}
                color="white"
                svg={AssetIconChevronRightSVG}
              />
            )}
          </Flex>

          <SVGIcon svg={AssetIconEyeSVG} />
          <Label>Version:</Label>
          <Text as="p" fontWeight="semibold">
            {previewsEnabled ? 'Preview Site' : 'Live Site'}
          </Text>
        </Grid>

        <ToggleButton
          alignSelf="center"
          justifySelf="end"
          toggle={togglePreviews}
          on={previewsEnabled}
          fontSize="small"
        />
      </Grid>
    </Text>
  ) : null
}
